// extracted by mini-css-extract-plugin
export default {"loader":"FeedCardCollapsedLoader_loader__igUCg"};